import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, null, -1)
const _hoisted_3 = { class: "row mb-10" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Advanced Assurance", -1)
const _hoisted_6 = ["onUpdate:modelValue", "name", "id"]
const _hoisted_7 = ["for"]
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Stage of Evolution", -1)
const _hoisted_11 = ["onUpdate:modelValue", "name"]
const _hoisted_12 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Minimum Traction", -1)
const _hoisted_15 = ["onUpdate:modelValue", "name"]
const _hoisted_16 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.advancedAssuranceOptions, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `as-${index}`,
            class: "form-check form-check-custom form-check-solid my-3"
          }, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fieldChanged($event))),
              "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
              class: "form-check-input",
              type: "checkbox",
              name: i.name,
              id: `advanced-assurance-${i.name}`
            }, null, 40, _hoisted_6), [
              [_vModelCheckbox, i.value]
            ]),
            _createElementVNode("label", {
              class: "form-check-label",
              for: `advanced-assurance-${i.name}`
            }, _toDisplayString(_ctx.enums[i.name]), 9, _hoisted_7)
          ]))
        }), 128)),
        (!_ctx.isAnyAdvancedAssuranceNotSelected && _ctx.touched)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Kindly select an advanced assurance value to continue "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageOfEvolution, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `soe-${index}`,
            class: "form-check form-check-custom form-check-solid my-3"
          }, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fieldChanged($event))),
              "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
              class: "form-check-input",
              type: "checkbox",
              name: i.name,
              id: "flexCheckDefault"
            }, null, 40, _hoisted_11), [
              [_vModelCheckbox, i.value]
            ]),
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.enums[i.name]), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minimumTraction, (i, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `mt-${index}`,
            class: "form-check form-check-custom form-check-solid my-3"
          }, [
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fieldChanged($event))),
              "onUpdate:modelValue": ($event: any) => ((i.value) = $event),
              class: "form-check-input",
              type: "checkbox",
              name: i.name,
              id: "flexCheckDefault"
            }, null, 40, _hoisted_15), [
              [_vModelCheckbox, i.value]
            ]),
            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.enums[i.name]), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}